import { GET_VEHICALLIST_REQUEST, GET_VEHICALLIST_SUCCESS, GET_VEHICALLIST_FAIL,
    GET_VEHICALHISTORY_REQUEST, GET_VEHICALHISTORY_SUCCESS, GET_VEHICALHISTORY_FAIL,
    GET_DOCUMENTLIST_REQUEST, GET_DOCUMENTLIST_SUCCESS, GET_DOCUMENTLIST_FAIL,
    CREATE_DOCUMENT_REQUEST, CREATE_DOCUMENT_SUCCESS, CREATE_DOCUMENT_FAIL, 
    UPLOAD_DOCUMENT_REQUEST, UPLOAD_DOCUMENT_SUCCESS, UPLOAD_DOCUMENT_FAIL,
    CHECK_VEHICLE_REQUEST, CHECK_VEHICLE_SUCCESS, CHECK_VEHICLE_FAIL
    } from '../types/documentTypes'
import Axios from 'axios'
import APP_CONSTANT from '../../config/constants'
import cogoToast from 'cogo-toast';
import { number } from 'yup';


export const checkVehicle = (vehicleId) => async (dispatch) => {
    dispatch({ type: CHECK_VEHICLE_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehicleId": vehicleId
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/document/checkVehicleInDocument`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: CHECK_VEHICLE_SUCCESS, payload: data });
        
        console.log("====Data", data)
        if( data.status === 1){
            cogoToast.warn("Document Already Exists")   
        }
        
    } catch (error) {
        dispatch({ type: CHECK_VEHICLE_FAIL, payload: error.message })
    }
}

export const createDocument = (uploadData) => async (dispatch) => {
    dispatch({ type: CREATE_DOCUMENT_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "docsData": uploadData,
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/document/store`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: CREATE_DOCUMENT_SUCCESS, payload: data });
        
        console.log("====Data", data)
        cogoToast.success(data.message, data.data)
        window.location.href = '/document'
    } catch (error) {
        dispatch({ type: CREATE_DOCUMENT_FAIL, payload: error.message })
    }
}

export const uploadDocument = (uploadData) => async (dispatch) => {
    dispatch({ type: UPLOAD_DOCUMENT_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehicleId": uploadData.vehicleId,
            "vehicleNo": uploadData.vehicleNo,
            "docId": uploadData.docId,
            "docTypeName": uploadData.docTypeName,
            "docFile": uploadData.docFile, 
            
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/document/uploadDocument`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        
        dispatch({ type: UPLOAD_DOCUMENT_SUCCESS, payload: data });

        //Toast for Upload Progress
        cogoToast.loading('Loading your data...').then(() => {
            if(data.status === 0){
                data.data.map((o,i) => {
                    return cogoToast.error(o?.vehicleId?.[i]) 
                }) 
            }else{
                return cogoToast.success('Data Successfully Loaded')
            }
        })
        
    } catch (error) {
        dispatch({ type: UPLOAD_DOCUMENT_FAIL, payload: error.message })
        
    }
}

export const getVehicleList = (id, pagination_details=false) => async (dispatch) => {

    dispatch({ type: GET_VEHICALLIST_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "searchString": "", 
            "vehicleId": id?.tags ? '' : id ? id : "",
            "expiryType":id?.tags ? id.ExpiryType :'',
            "page": pagination_details ? pagination_details.page : 1,
            "limit": pagination_details ? pagination_details.limit : 10,
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/document/getVehicleDocument`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VEHICALLIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_VEHICALLIST_FAIL, payload: error.message })
    }
}


export const getVehicleHistory = (id) => async (dispatch) => {
    dispatch({ type: GET_VEHICALHISTORY_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehicleId": id
        }
        console.log("headerData(GVH): ",headerData)
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/document/getDocumentHistory`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VEHICALHISTORY_SUCCESS, payload: data });
        //console.log("document history", data)
    } catch (error) {
        dispatch({ type: GET_VEHICALHISTORY_FAIL, payload: error.message })
    }
}


export const getDocumentList = () => async (dispatch) => {
    dispatch({ type: GET_DOCUMENTLIST_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId')
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/document/getDocument`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_DOCUMENTLIST_SUCCESS, payload: data });
        console.log('DocumentList Data: ', data)
    } catch (error) {
        dispatch({ type: GET_DOCUMENTLIST_FAIL, payload: error.message })
    }
}

